module.exports = __webpack_public_path__ + "media/images/emblems/Rickenbach(Turgovio)-Blazono-c5b449db96eb888d036a7a568a7bfba4.png";